import { joinURL } from 'ufo'
import type { CloudflareImage, CloudflareVariantSize } from '~~/layers/base/types/printingProcess'

export function useCloudflareImgUrl(imgId: string, variant: string): string
export function useCloudflareImgUrl(
    imgId: string,
    aspectRatio: CloudflareImage['aspectRatio'],
    size: CloudflareVariantSize
): string
/**
 * Utility function for composing the img url for a given imgId and variant
 */
export function useCloudflareImgUrl(
    imgId: string,
    aspect: CloudflareImage['aspectRatio'] | string,
    size?: CloudflareVariantSize
) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const config: any = useRuntimeConfig()
    const variant = size
        ? getCloudflareImgVariant(aspect as CloudflareImage['aspectRatio'], size)
        : aspect
    return joinURL(config.public.cloudflareImagesBaseUrl, imgId, variant)
}
